import * as React from 'react';

import { Form, FormField } from 'components/form/index';
import Input from 'components/inputs/input/Input';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { t } from 'utils/language';
import { isRequired } from 'utils/validators';

import type { ChangeEvent } from 'react';

type Props = {
  children?: React.ReactNode,
  placeholder: string,
  postUrlValidator: (b: string, a: string) => any,
  onSubmit: (a: string) => void,
  onUpdate?: () => void
};

type State = {
  url: string
};

class MediaPostForm extends React.PureComponent<Props, State> {
  state = {
    url: ''
  };

  handleFieldChanged = (event: ChangeEvent<HTMLInputElement>) => {
    const { onUpdate } = this.props;

    this.setState({
      url: event.target.value
    }, () => {
      if (onUpdate) {
        onUpdate();
      }
    });
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { url } = this.state;

    onSubmit(url);
  };

  render(): React.ReactNode {
    const { children, postUrlValidator, placeholder } = this.props;
    const { url } = this.state;

    return (
      <Form
        onSubmit={this.handleSubmit}
      >
        <div className="deliverable-media-post-form">
          <div className="deliverable-media-post-form__inner">
            <div className="deliverable-media-post-form__input">
              <FormField
                direction="column"
                showValidationIcon={false}
                validators={[
                  isRequired(url),
                  postUrlValidator(url, placeholder)
                ]}
              >
                <Input
                  onChange={this.handleFieldChanged}
                  name="url"
                  width="responsive"
                  value={url}
                  placeholder={placeholder}
                  data={{ qa: 'deliverable-media-post__input' }}
                />
                { children }
              </FormField>
            </div>
            <div className="deliverable-media-post-form__button">
              <ActionButton
                type="submit"
                data={{ qa: 'deliverable-media-post__submit' }}
              >
                {t('deliverable_media.button_add_link')}
              </ActionButton>
            </div>
          </div>
        </div>
      </Form>
    );
  }
}

export default MediaPostForm;
